import { Input } from "antd";
import axios from "axios";
import React, { useState } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import SelectComp from "../../../commons/Select/Select";
import GeneralModal from "../General.modal";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const AddDesignation = ({ updateParent, departments }) => {
  const { t } = useTranslation("dashboard");

  const [formData, setFormData] = useState({
    title: "",
    departmentId: ""
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { Title } = Typography;

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData({});
  };

  const handleChange = (key, val) => {
    setFormData({
      ...formData,
      [key]: val
    });
  };

  const onSubmit = async e => {
    if (!formData.departmentId || !formData.title) {
      Error(t("All fields are required"));
      return;
    }
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/designations/add`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const onChangetab = key => {};

  const items = (
    <div className="row form-row">
      <div className="col-12 col-sm-12">
        <div className="form-group">
          <Title level={5} className="modals-inputs-label">
            {t("Department")}
          </Title>
          <SelectComp
            handleChange={val => handleChange("departmentId", val)}
            options={departments}
            placeholder={t("Department")}
          />
        </div>
        <div className="form-group">
          <Title level={5} className="modals-inputs-label">
            {t("Title")}
          </Title>
          <Input
            onChange={e => handleChange("title", e.target.value)}
            type="text"
            placeholder={t("Title")}
            className="w-100"
            size="large"
            allowClear
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="AddDesignation">
      <MainButtonComp text="Add Designation" addBtn onClick={showModal} />
      <GeneralModal
        title={t("Add Designation")}
        onOk={() => onSubmit(formData)}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </div>
  );
};

export default AddDesignation;
